/** A shared lock survives nested surfaces and cleanup in either order. */
let locks = 0;
let previous = "";
let target: HTMLElement | null = null;
export function lockBodyScroll(): () => void {
  if (locks === 0) {
    target = document.body;
    previous = target.style.overflow;
  }
  locks += 1;
  if (target) target.style.overflow = "hidden";
  let released = false;
  return () => {
    if (released) return;
    released = true;
    locks -= 1;
    if (locks === 0) {
      if (target) target.style.overflow = previous;
      target = null;
    }
  };
}
